window.$ = document.querySelector.bind(document);
window.$$ = document.querySelectorAll.bind(document);

$("#mobileMenu").addEventListener("click", () => {
	$("#menu").classList.toggle("open");
});

window.addEventListener("resize", () => {
	$("#menu").classList.remove("open");
});

const acceptCookieBtn = $("#acceptCookies");
if (acceptCookieBtn) {
	acceptCookieBtn.addEventListener("click", () => {
		$(".cookie-wall").classList.add("hidden");
		localStorage.setItem("cookiesAccepted", true);
	});
}

// if cookies are accepted, remove
if (!localStorage.getItem("cookiesAccepted")) {
	$(".cookie-wall").classList.remove("hidden");
}
